/**
 * Eagerly registers the supported moment locales.
 *
 * Under webpack, moment's internal `require('./locale/' + name)` produced a
 * context module (pruned by moment-locales-webpack-plugin), so locale data
 * was bundled and `moment.locale('fr')` worked lazily. Rspack does not
 * follow moment's aliased require, so no locale context is created — this
 * shim (prepended to the entry) recreates one explicitly. The template
 * string below makes Rspack bundle `moment/locale/*`, which the
 * ContextReplacementPlugin in rspack.base.js prunes to SUPPORTED_DATELOCALES.
 */
const moment = require('moment')

const {
  SUPPORTED_DATELOCALES,
} = require('../../src/config/moment/moment.config')

SUPPORTED_DATELOCALES.filter((locale) => locale !== 'en').forEach((locale) => {
  require(`moment/locale/${locale}`)
})

// Registering a locale makes it active — restore the default.
moment.locale('en')
